import React from "react";
interface IconProps {
	fill: string;
	class?: string;
	className?: string;
	height: number;
}


export const EcoFilmIcon = (props: IconProps) => (
	<svg fill={props.fill} className={props.class} viewBox="0 0  233.393 233.393" width={props.height} height={props.height} >
		<g>
		<path d="M225.893,9.932H7.5c-4.143,0-7.5,3.358-7.5,7.5v141.343c0,4.142,3.357,7.5,7.5,7.5h46.803
	c-5.942,17.736-9.157,37.867,10.742,55.324c1.424,1.249,3.188,1.862,4.943,1.862c2.084,0,4.158-0.864,5.641-2.554
	c2.732-3.114,2.422-7.853-0.691-10.584c-14.063-12.336-11.571-25.155-4.728-44.047h43.494c-5.943,17.737-9.157,37.867,10.742,55.324
	c1.424,1.249,3.188,1.862,4.943,1.862c2.084,0,4.158-0.864,5.641-2.554c2.732-3.114,2.422-7.853-0.691-10.584
	c-14.064-12.336-11.571-25.155-4.728-44.047h43.497c-5.943,17.737-9.157,37.867,10.743,55.324c1.423,1.249,3.187,1.862,4.942,1.862
	c2.084,0,4.158-0.864,5.642-2.554c2.731-3.114,2.421-7.853-0.693-10.584c-14.064-12.336-11.571-25.155-4.728-44.047h36.878
	c4.143,0,7.5-3.358,7.5-7.5V17.432C233.393,13.29,230.035,9.932,225.893,9.932z M218.393,151.275h-23.92
	c5.075-15.143,8.157-32.032-3.435-47.51l8.201-6.882c1.252-1.051,1.912-2.647,1.767-4.275c-0.146-1.628-1.078-3.082-2.497-3.895
	l-45.855-26.235c-1.819-1.04-4.092-0.837-5.697,0.51c-1.604,1.346-2.2,3.55-1.491,5.522l17.874,49.713
	c0.553,1.538,1.823,2.709,3.401,3.135c0.431,0.116,0.868,0.173,1.304,0.173c1.161,0,2.303-0.405,3.214-1.17l8.264-6.934
	c7.433,10.551,4.753,22.085-0.957,37.848h-43.496c5.076-15.143,8.158-32.032-3.434-47.511l8.2-6.881
	c1.252-1.051,1.912-2.647,1.767-4.275c-0.146-1.628-1.078-3.082-2.497-3.895L93.252,62.478c-1.818-1.04-4.092-0.837-5.697,0.51
	c-1.604,1.346-2.2,3.55-1.491,5.521l17.873,49.713c0.553,1.538,1.823,2.709,3.401,3.136c0.431,0.116,0.868,0.173,1.304,0.173
	c1.162,0,2.303-0.405,3.214-1.17l8.265-6.934c7.433,10.55,4.753,22.085-0.958,37.848H75.668c5.075-15.143,8.157-32.032-3.435-47.511
	l8.2-6.881c1.252-1.051,1.912-2.647,1.767-4.275c-0.146-1.628-1.078-3.082-2.497-3.895L33.851,62.478
	c-1.819-1.04-4.092-0.837-5.697,0.51c-1.604,1.346-2.2,3.55-1.491,5.521l17.873,49.713c0.553,1.538,1.823,2.709,3.401,3.136
	c0.431,0.116,0.868,0.173,1.304,0.173c1.162,0,2.303-0.405,3.214-1.17l8.264-6.934c7.433,10.551,4.753,22.085-0.957,37.848H15
	V24.932h203.393V151.275z"/>


		</g>

	</svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/EcoFilm.tsx